export const mixin = {
    methods:{
        // 上传地址（/api 前缀：生产由 Nginx 反代，开发由 webpack 代理重写）
        uploadImageUrl(){
            return this.$store.state.HOST + "/api/common/uploadImg"
        },
        uploadAvatarUrl(){
            return this.$store.state.HOST + "/api/user/setUserAvatar"
        },
        uploadFileUrl(){
            return this.$store.state.HOST + "/api/common/uploadFile"
        },
        uploadVideoUrl(){
            return this.$store.state.HOST + "/api/common/uploadVideo"
        },
        // el-upload 不走 request.js 拦截器，需手动携带鉴权头
        uploadHeaders(){
            return { 'x_access_token': window.localStorage.getItem('token') }
        },
        // 头像地址：为空时返回默认头像，避免破图
        avatarSrc(avatar){
            if(!avatar) return require('../assets/image/avatar.jpeg')
            return this.$store.state.HOST + avatar
        },
        // 头像加载失败时回退到默认头像
        onAvatarError(e){
            e.target.onerror = null
            e.target.src = require('../assets/image/avatar.jpeg')
        },
        // 文件超出个数限制时的钩子
        handleExceed(files, fileList) {
            this.$message.warning("当前文件数量超出上传限制");
        },
        //上传图片之前的校验
        beforeAvatorUpload(file){
            const isLt2M = (file.size / 1024 /1024) < 2;
            if(!isLt2M){
                this.$message.error('上传图片单张大小不能超过2MB');
                return false;
            }
            return true;
        },
        handleExceed(files, fileList) {
            this.$message.warning(`本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件,超出文件个数限制`);
        },
    }
}


